<template>
  <div>
  <el-dialog
    v-if="status"
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    width="620px"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <!-- 驳回 -->
      <div v-if="dialogType === 'disagree'">
        <el-form-item :label="$t('zlfk.bhyy')+':'" prop="auditText">
          <el-input
            v-model="form.auditText"
            type="textarea"
            :placeholder="$t('placeholder.enter')"
            :autosize="{ minRows: 4, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button
        class="primary-btn lang-but"
        type="primary"
        @click="handleSave"
      >
        {{ $t("seek.submit") }}
      </el-button>
      <el-button
        class="primary-btn lang-but"
        plain
        @click="dialogVisible = false"
      >
        {{$t("seek.cancel")}}
      </el-button>
    </div>
    <next-dialog ref="nextDialog" />
  </el-dialog>
  </div>

</template>

<script>
import { preAfterSalesQuestionListApi, auditProblem  } from "@/api/feedback";
import UploadFile from "@/components/uploadNew.vue";
import NextDialog from "./nextDialog.vue";
import { dealerAccept, dealerReject } from "@/util/qualityUtil/dealerAudit";
export default {
  components: { UploadFile, NextDialog },
  data() {
    return {
      title: "", // 弹窗标题
      dialogType: "", // 弹窗类型
      dialogVisible: false,
      form: this.getForm(),
      rules: {
        auditText: [{ required: true, message: " " }],
        emergencyMeasure: [{ required: true, message: " " }],
        marketLanguage: [{ required: true, message: " " }],
      },
      examineTip: "",
      status:false,
    };
  },
  computed: {
    labelWidth() {
      if (this.dialogType === 'accept') {
        const widthMap = {
         "zh": "90px",
         "ru": "265px",
         "en": "180px",
         "vi": "145px",
         "es": "215px"
        };
        return widthMap[this.$i18n.locale] || "115px";
      }
      if (this.dialogType === 'disagree') {
        const widthMap = {
         "zh": "85px",
         "ru": "150px",
         "en": "165px",
         "vi": "115px",
         "es": "150px"
        };
        return widthMap[this.$i18n.locale] || "85px";
      }
    }
  },
  mounted() {},
  methods: {
    // 初始化 title-弹窗标题，examineTip-审核完成提示，data-审核传参，dialogType-审核弹窗
    async init(title, examineTip, data = {}, dialogType) {
      this.form = this.getForm(data);
      this.title = title;
      this.examineTip = examineTip;
      this.dialogType = dialogType;

      if (data.variables.approval){
        this.status = false
        this.auditPassClick()
      } else {
        this.status=true
        this.dialogVisible = true;
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
      }
    },
    // 获取表单对象
    getForm(data = {}) {
      return {
        feedbackFormId: data.feedbackFormId || "",
        questionNum: data.questionNum || "",
        auditText: "",
        ...data,
      };
    },
    async getQuestionList() {
      const res = await preAfterSalesQuestionListApi({
        data: {
          feedbackFormId: this.problemData.feedbackFormId,
          questionNum: this.problemData.questionNum,
        },
        page: {
          pageNum: 1,
          pageSize: 1,
        },
      });
      this.problemData = { ...res.data?.records[0] };
      setStorageNew("problemData", this.problemData);
      this.form = this.getForm(this.problemData);
    },
    // 认可
    auditPassClick(){
      dealerAccept(this, this.form);
    },
    // 保存
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        dealerReject(this, this.form, 'reject');
      });
    },
    // 审核
    async audit() {
      try {
        const submitData = JSON.parse(JSON.stringify(this.form));
        const res = await auditProblem({ data: submitData });
        if (res.status == 0) {
          this.dialogVisible = false;
          this.$refs.nextDialog.init(this.examineTip);
          this.$emit("success");
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
